import React, {useContext} from "react";
import styles from "./Overview.module.css";
import Grid from "@mui/material/Grid";
import { LinearProgress, Typography } from "@mui/material";
import AppButton from "component/button/AppButton";
import overview_underlay from "assets/images/overview_underlay.svg";
import { useNavigate } from "react-router";
import {UserContext} from 'context/UserContext'

function Overview({ setOpenModal }) {
  const {user} = useContext(UserContext)
  const navigate = useNavigate()
  return (
    <div className={styles.overview}>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={12} md={12} lg={8}>
          <div className={styles.primary_overview}>
            <div className={styles.primary_overview_main}>
              {/* <Typography variant="h5">Outstanding Payment</Typography>
              <Typography variant="h6">N 0</Typography>
              <Typography>You have repaid N 0</Typography> */}
              <div className={styles.overview_btn}>
                {/* <button
                  onClick={() => {
                 
                    setOpenModal(true);
                  }}
                >
                  Make Payment
                </button> */}
              </div>
            </div>
            <div className={styles.overview_underlay}>
              <img src={overview_underlay} alt="" />
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={4}>
          <div className={styles.secondary_overview}>
            <Typography variant="h6">Congratulations {user?.firstName} 🥳</Typography>
            {/* <Typography>Profile {user?.percentage_complete}% Completed</Typography> */}

            <AppButton
              handleAction={() => {
                navigate('/applications')
              }}
              
              fullwidth
              textColor="#FFFFFF"
              btnBg="#0072CE"
              btnText="Proceed To Application"
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default Overview;
